<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row mt-2">
        <div class="col-md-12">
          <h1 class="ts-py-2">{{ $t('subjectGradingRange.grading') }}</h1>
          <div
            class="ts-border ts-rounded ts-border-gray-200 ts-border-opacity-20 ts-p-3"
          >
            <div class="row form-group">
              <div class="col-md-4">
                <label class="required ts-text-xs">
                  {{ $t('subjectGradingRange.subject') }}
                </label>
                <a-select
                  v-model="selectedSubject"
                  mode="multiple"
                  :options="subjectOption"
                  style="width:100%"
                  @change="createItem"
                ></a-select>
              </div>
              <div class="col-md-2">
                <label class="required ts-text-xs">
                  {{ $t('subjectGradingRange.definitionType') }}
                </label>
                <select
                  class="form-control"
                  v-model="model.definition_type"
                  @change="createItem"
                >
                  <option :value="null">{{ $t('select') }}</option>
                  <option
                    v-for="(grading, index) in definitonTypes"
                    :key="index"
                    :value="grading"
                    >{{ grading }}</option
                  >
                </select>
              </div>
              <div class="col-md-2">
                <label class="required ts-text-xs">{{ $t('school.academic.setup.program.grade.scoring_version') }}</label>
                <a-select
                  v-model.number="model.score_version_id"
                  style="width: 100%"
                  showSearch
                  :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())"
                >
                  <a-select-option v-for="v in scoringVersions" :key="v.id" :value="v.id">{{ v.version_name }}</a-select-option>
                </a-select>
              </div>
              <div class="col-md-6 d-flex align-items-end">
                <div class="ts-inline-block ts-text-xs mr-2">
                  <ts-checkbox v-model="model.is_percentage">
                    {{ $t('subjectGradingRange.percentage') }}
                  </ts-checkbox>
                </div>
                <div class="ts-inline-block ts-text-xs mr-2">
                  <ts-checkbox
                    v-model="model.enable_semester"
                    @change="enableSemester"
                    >{{ $t('subjectGradingRange.enableSemester') }}</ts-checkbox
                  >
                </div>
                <div class="ts-inline-block ts-text-xs">
                  <ts-checkbox
                    v-model="model.enable_sciense"
                    @change="enableSciense"
                    >{{ $t('subjectGradingRange.enableSciense') }}</ts-checkbox
                  >
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-12">
                <label class="required ts-text-xs">
                  {{ $t('subjectGradingRange.scoreList') }}
                </label>
                <table class="table table-hover ui-table">
                  <thead>
                    <tr>
                      <th class="ts-text-xs ts-whitespace-no-wrap">
                        {{ $t('subjectGradingRange.grading') }}
                      </th>
                      <th class="ts-text-xs">
                        {{ $t('subjectGradingRange.minScore') }}
                      </th>
                      <th class="ts-text-xs">
                        {{ $t('subjectGradingRange.maxScore') }}
                      </th>
                      <th class="ts-text-xs">
                        {{ $t('subjectGradingRange.minScoreSemester') }}
                      </th>
                      <th class="ts-text-xs">
                        {{ $t('subjectGradingRange.maxScoreSemester') }}
                      </th>
                      <th class="ts-text-xs ts-whitespace-no-wrap">
                        {{ $t('subjectGradingRange.minScoreSciense') }}
                      </th>
                      <th class="ts-text-xs ts-whitespace-no-wrap">
                        {{ $t('subjectGradingRange.maxScoreSciense') }}
                      </th>
                      <th class="ts-text-xs">
                        {{ $t('subjectGradingRange.pass') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody v-if="selectedSubject.length > 0">
                    <tr
                      v-for="(item, index) in model.subject_score_grading_list"
                      :key="index"
                    >
                      <td class="text-left ts-text-xs" valign="middle">
                        <input
                          type="text"
                          :value="gradingName(item.grade_definition_id)"
                          readonly
                          class="form-control"
                          style="width:40px"
                        />
                      </td>
                      <td>
                        <input
                          v-model.number="item.score_start"
                          type="number"
                          class="form-control"
                        />
                        <div
                          class="validate ts-text-xs"
                          v-if="
                            errors.has(
                              'subject_score_grading_list.' +
                                index +
                                '.score_start'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'subject_score_grading_list.' +
                                index +
                                '.score_start'
                            )
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          v-model.number="item.score_stop"
                          type="number"
                          class="form-control"
                        />
                        <div
                          class="validate ts-text-xs"
                          v-if="
                            errors.has(
                              'subject_score_grading_list.' +
                                index +
                                '.score_stop'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'subject_score_grading_list.' +
                                index +
                                '.score_stop'
                            )
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          v-model.number="item.semester_score_start"
                          :disabled="!model.enable_semester"
                          type="number"
                          class="form-control"
                        />
                        <div
                          class="validate ts-text-xs"
                          v-if="
                            errors.has(
                              'subject_score_grading_list.' +
                                index +
                                '.semester_score_start'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'subject_score_grading_list.' +
                                index +
                                '.semester_score_start'
                            )
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          v-model.number="item.semester_score_stop"
                          :disabled="!model.enable_semester"
                          type="number"
                          class="form-control"
                        />
                        <div
                          class="validate ts-text-xs"
                          v-if="
                            errors.has(
                              'subject_score_grading_list.' +
                                index +
                                '.semester_score_stop'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'subject_score_grading_list.' +
                                index +
                                '.semester_score_stop'
                            )
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          v-model.number="item.sciense_score_start"
                          :disabled="!model.enable_sciense"
                          type="number"
                          class="form-control"
                        />
                        <div
                          class="validate ts-text-xs"
                          v-if="
                            errors.has(
                              'subject_score_grading_list.' +
                                index +
                                '.sciense_score_start'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'subject_score_grading_list.' +
                                index +
                                '.sciense_score_start'
                            )
                          }}
                        </div>
                      </td>
                      <td>
                        <input
                          v-model.number="item.sciense_score_stop"
                          :disabled="!model.enable_sciense"
                          type="number"
                          class="form-control"
                        />
                        <div
                          class="validate ts-text-xs"
                          v-if="
                            errors.has(
                              'subject_score_grading_list.' +
                                index +
                                '.sciense_score_stop'
                            )
                          "
                        >
                          {{
                            errors.first(
                              'subject_score_grading_list.' +
                                index +
                                '.sciense_score_stop'
                            )
                          }}
                        </div>
                      </td>
                      <td>
                        <ts-checkbox v-model="item.is_pass"></ts-checkbox>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'

export default {
  name: 'subjectGrading',
  props: ['value', 'gradeDefinitions', 'subjects', 'validate', 'scoringVersions'],
  data () {
    return {
      loading: false,
      errors: new Errors(),
      createdItemId: [],
      selectedSubject: [],
      model: {},
      definitonTypes: ['Grading', 'Rating']
    }
  },
  computed: {
    subjectOption () {
      return this.subjects
      // .filter(
      //   s =>
      //     this.createdItemId.filter(
      //       el =>
      //         el.subject_id == s.subject_id &&
      //         el.grade_id == this.model.grade_id
      //     ).length == 0
      // )
    }
  },
  created () {
    this.model = this.value
    this.fetchCreated()
  },
  methods: {
    ...mapActions('subjectGradingRange', ['getSubjectGradingCreated']),
    fetchCreated () {
      this.loading = true
      this.createdItemId = []
      this.getSubjectGradingCreated()
        .then(response => {
          this.createdItemId = response.data.map(el => ({
            subject_id: el.grade_subject.subject_id,
            grade_id: el.grade_subject_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    createItem () {
      this.model.subject_score_grading_list = []

      if (!this.selectedSubject.length > 0) return

      this.gradeDefinitions
        .filter(g => g.definition_type == this.model.definition_type)
        .forEach(el => {
          this.model.subject_score_grading_list.push({
            grade_subject_grading_id: 0,
            grade_subject_id: null,
            score_start: null,
            score_stop: null,
            semester_score_start: null,
            semester_score_stop: null,
            sciense_score_start: null,
            sciense_score_stop: null,
            grade_definition_id: el.value,
            is_pass: false
          })
        })
    },
    gradingName (id) {
      return this.gradeDefinitions
        .filter(g => g.value == id)
        .reduce((init, item) => (init = item.label), null)
    },
    enableSemester () {
      this.model.subject_score_grading_list.forEach(el => {
        el.semester_score_start = null
        el.semester_score_stop = null
      })
    },
    enableSciense () {
      this.model.subject_score_grading_list.forEach(el => {
        el.sciense_score_start = null
        el.sciense_score_stop = null
      })
    }
  },
  watch: {
    gradeDefinitions: {
      handler () {
        this.createItem()
      },
      deep: true,
      immediately: true
    },
    validate: function (error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
.table > thead > tr > th {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  align-items: center;
}
</style>
